import React, { PureComponent } from 'react';

import { InputField } from '@eventbrite/eds-input-field';
import { ValidationFormField } from '@eventbrite/eds-validation-form-field';

class PageHeaderEdit extends PureComponent {
    render() {
        return (
            <section className="user-collection__header--edit-mode">
                <ValidationFormField v2={true} label="name" name="name">
                    <InputField
                        name="name"
                        id="name"
                        type="text"
                        label="name"
                    />
                </ValidationFormField>
                <ValidationFormField v2={true} label="summary" name="summary">
                    <InputField
                        name="summary"
                        id="summary"
                        type="text"
                        label="summary"
                        isMultiline={true}
                        rows={5}
                    />
                </ValidationFormField>
                {this.props.ownerActionBarNode}
            </section>
        );
    }
}

export default PageHeaderEdit;
